(function () {

    angular
        .module('smartertoolsApp')
        .controller('leaseActivityReportController', ['leaseProviderService', leaseActivityReportController]);

    function leaseActivityReportController(leaseProviderService) {
        var vm = this;
        vm.isLoading = true;

        // Functions
        vm.refreshData = refreshData;
        vm.csvHeader = csvHeader;
        vm.csvData = csvData;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refreshData();
        }

        function csvHeader() { return ['Date', 'Lease Id', 'Description']; }

        function csvData() {
            var items = [];
            for (let i = 0; i < vm.activityReportItems.length; i++) {
                const a = vm.activityReportItems[i];
                items.push([
                    moment(a.Date).format(),
                    a.LeaseId,
                    a.Description
                ]);
            }
            return items;
        }

        function refreshData() {
            leaseProviderService.getActivityReport()
                .then((data) => {
                    vm.activityReportItems = data.Items;
                    vm.isLoading = false;
                })
                .catch((e) => {
                    if (e.status == 403) {
                        window.location.href = '/company/partners';
                        return;
                    }
                    vm.loadingError = 'There was a problem loading this information.  Please try again later.';
                });
        }
    }

})();